<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
      <v-col cols="4">
        <app-select-mapeamento
          :mapeamento="mapeamento"
          :mapeamentos="mapeamentos"
          @return="(value) => (mapeamento = value)"
        />
      </v-col>
    </v-row>
    <v-card-widget title="Dashboard">
      <div slot="widget-content">
        <app-timeline :itens="timelineItens" />
      </div>
    </v-card-widget>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VCardWidget from '@/components/VWidget';
import AppSelectMapeamento from '@/components/core/AppSelectMapeamento';
import AppTimeline from '@/components/core/AppTimeline';

export default {
  name: 'DashboardGerenciamento',

  components: { VCardWidget, AppSelectMapeamento, AppTimeline },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
    }),
    ...mapGetters({
      getMapeamento: 'mapeamento/getMapeamento',
      getMapeamentos: 'mapeamento/getMapeamentos',
    }),
    mapeamento: {
      get() {
        return this.getMapeamento('COMISSAO');
      },
      set(mapeamento) {
        const payload = { tipo: 'COMISSAO', mapeamento };
        this.$store.dispatch('mapeamento/setMapeamento', payload);
      },
    },
    mapeamentos() {
      return this.getMapeamentos('COMISSAO');
    },
    timelineItens() {
      const timelineItens = [
        {
          visibilidade: true,
          titulo: 'Programação do Mapeamento',
          textos: [
            'A programação do mapeamento tem o objetivo de cadastrar as unidades que serão mapeadas e definir '
              + 'o cronograma do mapeamento comportamental e técnico.',
          ],
          cor: 'primary',
          icone: 'construction',
          link: '/gerenciamento/programacao-mapeamento',
        },
        {
          visibilidade: true,
          titulo: 'Programação do Diagnóstico',
          textos: [
            'Tem o objetivo de definir o cronograma do diagnóstico comportamental e técnico.',
          ],
          cor: 'primary',
          icone: 'construction',
          link: '/gerenciamento/programacao-diagnostico',
        },
        {
          visibilidade: true,
          titulo: 'Gerenciamento de Dispensas do Diagnóstico',
          textos: [
            'Tem o objetivo de gerenciar as dispensas dos diagnósticos do sistema.',
          ],
          cor: 'primary',
          icone: 'construction',
          link: '/gerenciamento/dispensa-diagnostico',
        },
      ];

      if (this.mapeamento) {
        timelineItens.push(
          {
            visibilidade: this.mapeamento,
            titulo: 'Normalização Comportamental',
            textos: [
              'A normalização comportamental tem o objetivo de filtrar os comportamentos indicados pelos servidores '
                + 'e associá-los a uma competência comportamental.',
            ],
            cor: 'success',
            icone: 'playlist_add_check',
            link: '/gerenciamento/normalizacao-comportamento',
            dataInicial: this.mapeamento.inicioPerComportComissao,
            dataFinal: this.mapeamento.fimPerComportComissao,
            exibeStatus: true,
          },
          {
            visibilidade: this.mapeamento,
            titulo: 'Normalização das Competências Técnicas',
            textos: [
              'A normalização das competências técnicas tem o objetivo de realizar ajustes nas responsabilidades '
                + 'cadastradas.',
            ],
            cor: 'secondary',
            icone: 'edit_note',
            link: '/gerenciamento/normalizacao-responsabilidade',
            dataInicial: this.mapeamento.inicioPerRespCom,
            dataFinal: this.mapeamento.fimPerRespCom,
            exibeStatus: true,
          },
          {
            visibilidade: this.mapeamento,
            titulo: 'Consolidação das Competências Técnicas',
            textos: [
              'A consolidação das competências técnicas tem o objetivo de definir um instrumento de avaliação '
                + 'das responsabilidades que será utilizado na etapa diagnóstico.',
            ],
            cor: 'secondary',
            icone: 'recent_actors',
            link: '/gerenciamento/consolidacao-responsabilidade',
            dataInicial: this.mapeamento.inicioPerRespConsol,
            dataFinal: this.mapeamento.fimPerRespConsol,
            exibeStatus: true,
          },
        );
      }

      return timelineItens;
    },
  },

  updated() {
    if (!this.comissao) {
      this.$router.push('/403');
    }
  },
};
</script>
